import { render, staticRenderFns } from "./InstanceEditSingleSignOn.vue?vue&type=template&id=08eb0536&scoped=true&"
import script from "./InstanceEditSingleSignOn.vue?vue&type=script&lang=js&"
export * from "./InstanceEditSingleSignOn.vue?vue&type=script&lang=js&"
import style0 from "./InstanceEditSingleSignOn.vue?vue&type=style&index=0&id=08eb0536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb0536",
  null
  
)

export default component.exports